import { DateTime } from 'luxon';

const format = {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h12',
};

export function displayFromISO(timeISO: string | null) {
  return timeISO && toDisplay(DateTime.fromISO(timeISO)).replace(/^0+/, '');
}

export function displayFromSeconds(seconds: number | null) {
  return seconds && toDisplay(DateTime.fromSeconds(seconds)).replace(/^0+/, '');
}

export function secondsToDateObject(seconds: number) {
  return {
    hour: DateTime.fromSeconds(seconds).toFormat('hh'),
    minute: DateTime.fromSeconds(seconds).toFormat('mm'),
    period: DateTime.fromSeconds(seconds).toFormat('a'),
    day: DateTime.fromSeconds(seconds).toFormat('dd'),
    month: DateTime.fromSeconds(seconds).toFormat('MM'),
    year: DateTime.fromSeconds(seconds).toFormat('yyyy'),
  };
}

export function isoDateToDateObject(timeISO: string) {
  return {
    hour: DateTime.fromISO(timeISO).toFormat('hh'),
    minute: DateTime.fromISO(timeISO).toFormat('mm'),
    period: DateTime.fromISO(timeISO).toFormat('a'),
    day: DateTime.fromISO(timeISO).toFormat('dd'),
    month: DateTime.fromISO(timeISO).toFormat('MM'),
    year: DateTime.fromISO(timeISO).toFormat('yyyy'),
  };
}

export function dateToSeconds(
  year: number,
  month: number,
  day: number,
  hour: number,
  minute: number
) {
  return DateTime.fromObject({
    year,
    month,
    day,
    hour,
    minute,
  }).toSeconds();
}

export function dateToIsoDate(
  year: number,
  month: number,
  day: number,
  hour: number,
  minute: number
) {
  return DateTime.fromObject({
    year,
    month,
    day,
    hour,
    minute,
  }).toISO();
}

export function isoDateToSeconds(timeISO: string) {
  return DateTime.fromISO(timeISO).toSeconds();
}

export function secondsToIsoDate(timeSeconds: number) {
  return DateTime.fromSeconds(timeSeconds).toISO();
}

function toDisplay(date: any) {
  return date.toLocaleString(format);
}

export function toTwelveHourTime(time?: string) {
  if (!time) {
    return '';
  }

  const date = new Date(time);
  return date.toLocaleString('en-AU', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
}

export function setOnTheMinuteInterval(
  callback: () => void,
  callOnStart = false
) {
  if (callOnStart) {
    callback();
  }

  const MILLISECONDS_IN_MINUTE = 60 * 1000;
  const millisecondsUntilMinuteChanges =
    MILLISECONDS_IN_MINUTE -
    new Date().getSeconds() * 1000 -
    new Date().getMilliseconds();

  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      callback();
      resolve([timeout, setInterval(callback, MILLISECONDS_IN_MINUTE)]);
    }, millisecondsUntilMinuteChanges);
  });
}

export function displayFromISOWithWeekday(timeISO: string) {
  const date = new Date(timeISO);

  return date
    .toLocaleDateString('en-AU', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    })
    .replace(',', '');
}
